import { Card, Select, Tag, Typography, Divider, Space, Button, message } from "antd";

const { Text } = Typography;

const AnalyticsConfigurationCard = ({
  modalSelection,
  dependentVariable,
  groupBy,
  onChangeModal,
  onChangeDependent,
  onChangeGroupBy,
  dependentOptions,
  groupByOptions,
  onConfigure,
  applying,
  applyResponse,
  MODEL_OPTIONS,
  onBackToDashboard,
}) => (
  // console.log("AnalyticsConfigurationCard modalSelection", modalSelection),
  <Card
    title={<span className="font-semibold text-xl text-white">Analytics Configuration</span>}
    className="bg-[#141c31] shadow-sm pt-10"
  >
    {/* Model Selection */}
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <Text strong className="text-white">Model Selection</Text>
        <Text type="secondary" className="text-xs !text-gray-100">
          Select one model to analyze
        </Text>
      </div>

      <Select
        showSearch
        value={modalSelection}
        onChange={onChangeModal}
        className="w-full"
        size="large"
        placeholder="Select a model"
        options={MODEL_OPTIONS}
        allowClear
      />
    </div>

    <Divider className="my-5" />

    {/* Dependent Variable */}
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <Text strong className="text-white">Dependent Variable</Text>
        <Text type="secondary" className="text-xs !text-gray-100">
          Select one numeric column to analyze
        </Text>
      </div>

      <Select
        showSearch
        value={dependentVariable}
        onChange={onChangeDependent}
        className="w-full"
        size="large"
        placeholder="Select a column"
        options={dependentOptions}
        allowClear
      />
    </div>

    <Divider className="my-5" />

    {/* Group By Variables */}
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <Text strong className="text-white">Group By Variables</Text>
        <Text type="secondary" className="text-xs !text-gray-100">
          {modalSelection === "benford" 
            ? "Not required for Benford Analysis" 
            : modalSelection === "rsf" 
            ? "Required for RSF Analysis (Select up to 3 columns for grouping)" 
            : `Select up to 3 columns for grouping (${groupBy.length}/3)`}
        </Text>
      </div>

      <Select
        showSearch
        mode="multiple"
        value={groupBy}
        onChange={onChangeGroupBy}
        maxTagCount={3}
        size="large"
        allowClear
        className="w-full"
        placeholder={modalSelection === "benford" ? "Disabled for Benford analysis" : "Select columns to group by"}
        options={groupByOptions}
        disabled={modalSelection === "benford"}
        status={modalSelection === "rsf" && groupBy.length === 0 ? "error" : ""}
      />
      {/* <div className="mt-3 flex flex-wrap gap-2">
        {groupBy.map((g) => (
          <Tag
            key={g}
            closable
            onClose={(e) => {
              e.preventDefault();
              onChangeGroupBy(groupBy.filter((x) => x !== g));
            }}
            color="blue"
            className="rounded-full px-3 py-1"
          >
            {g}
          </Tag>
        ))}
      </div> */}
    </div>

    <Space direction="vertical" className="w-full">
      <Button
        type="primary"
        size="large"
        className="w-full"
        onClick={() => {
          // Validate RSF requirement
          if (modalSelection === "rsf" && groupBy.length === 0) {
            message.error("Group By Variables are required for RSF analysis");
            return;
          }
          
          onConfigure({
            models: [String(modalSelection).toLowerCase().replace(/\s|-/g, "")],
            dep_variable: dependentVariable,
            groupby_columns: groupBy,
          });
        }}
        loading={applying}
        disabled={modalSelection === "rsf" && groupBy.length === 0}
      >
        Configure Analytics
      </Button>


      {applyResponse?.blob_download_link && (
        <Button
          type="default"
          size="large"
          className="w-full bg-green-600 hover:!bg-green-700 !text-white"
          onClick={() => onBackToDashboard()}
          disabled={applying}
        >
          View Analytics Results
        </Button>
      )}
    </Space>
  </Card>
);

export default AnalyticsConfigurationCard;